export default {
      id: "playCircleOutline-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#playCircleOutline-usage",
      toString: function () {
        return this.url;
      }
    }